export const redirectConfig = {
  abashirigawa: '8101100001',
  abekawa: '8505020001',
  abukumagawa: '8202010001',
  aganogawa: '8404020001',
  akagawa_2: '8202120001',
  arakawa_1: '8303040001',
  arakawa_2: '8404010001',
  aritagawa: '3000770001',
  asahikawa: '8707120001',
  ashidagawa: '8707100001',
  banjougawa: '8909170001',
  chikugogawa: '8909060001',
  chikusagawa: '2800640001',
  chiyokawa: '8707010001',
  dogawa: '8808030001',
  dokigawa: '8808080001',
  fujikawa: '8303080001',
  fushinogawa: '3500360001',
  gokasegawa: '8909160001',
  gounokawa: '8707050001',
  hidakagawa: '3000660001',
  hiikawa: '8707040001',
  hijikawa: '8808020001',
  himekawa_2: '8404050001',
  hinogawa: '8707030001',
  hirotogawa: '4500400001',
  honmeigawa: '8909030001',
  ibogawa: '8606060001',
  ichikawa: '2800530001',
  ishikarigawa: '8101030001',
  iwakigawa: '8202070001',
  jinzuugawa: '8404080001',
  jouganjigawa: '8404070001',
  kakehashigawa: '8404120001',
  kakogawa: '8606050001',
  kanogawa: '8505010001',
  kasegawa: '8909050001',
  katsuuragawa: '3600070001',
  kikuchigawa: '8909080001',
  kikukawa: '8505040001',
  kimotsukigawa: '8909130001',
  kinokawa_2: '8606020001',
  kisogawa: '8505090001',
  kitagawa_2: '8606080001',
  kitakamigawa: '8202040001',
  kotougawa: '3500460001',
  koutougawa: '3700260001',
  koyoshigawa: '8202100001',
  kozagawa: '3000130001',
  kujigawa_2: '8303010001',
  kumagawa: '8909110001',
  kumozugawa: '8505110001',
  kurobegawa: '8404060001',
  kurosegawa: '3400210001',
  kushidagawa: '8505120001',
  kushirokawa: '8101090001',
  kuzuryuugawa: '8606070001',
  mabechigawa: '8202050001',
  manosegawa: '4600600001',
  maruyamagawa_2: '8606100001',
  masudagawa: '3200040001',
  matsuuragawa: '8909020001',
  midorikawa_2: '8909100001',
  mikasagawa: '4000180001',
  minamikawa: '1800060001',
  miyagawa_1: '8505130001',
  miyakodagawa: '2200810001',
  mogamigawa: '8202110001',
  monobegawa: '8808050001',
  mukawa: '8101060001',
  mukogawa: '2800140001',
  nakagawa_1: '8303020001',
  nakagawa_4: '8808060001',
  nanakitagawa: '0400280001',
  narusegawa: '8202030001',
  natorigawa: '8202020001',
  natsuigawa: '0700280001',
  niidagawa_2: '0700100001',
  nikkougawa_1: '0600160001',
  nikkougawa_2: '2300540001',
  nishikigawa: '3500020001',
  niyodogawa: '8808040001',
  nutagawa: '3400130001',
  omarugawa: '8909150001',
  omonogawa: '8202090001',
  ongagawa: '8909010001',
  ooigawa_1: '8505030001',
  ooitagawa: '8909190001',
  oonokawa_3: '8909180001',
  ootagawa_3: '2200790001',
  ootagawa_5: '8707090001',
  ootsugawa_3: '2700130001',
  ooyodogawa: '8909140001',
  oyabegawa: '8404100001',
  ozegawa: '8707080001',
  rokkakugawa: '8909040001',
  rumoigawa: '8101020001',
  sabagawa: '8707070001',
  sagamigawa: '8303070001',
  sakaigawa_2: '2300290001',
  sakawagawa: '1400190001',
  sarugawa: '8101070001',
  sasagasegawa: '3300090001',
  sekikawa_1: '8404040001',
  sendaigawa: '8909120001',
  shigenobugawa: '8808010001',
  shimadagawa: '3500190001',
  shinanogawa: '8404030001',
  shinguugawa: '8606010001',
  shinkawa_1: '0101750001',
  shirakawa: '8909090001',
  shiribeshitoshibetsugawa: '8101050001',
  shiribetsugawa: '8101040001',
  shokotsugawa: '8101130001',
  shougawa: '8404090001',
  shounaigawa: '8505080001',
  shounokawa: '1800140001',
  sufugawa: '3200110001',
  suzukagawa: '8505100001',
  takahashigawa_2: '8707110001',
  takasegawa_1: '8202060001',
  takatsugawa: '8707060001',
  tamagawa_2: '8303050001',
  tedorigawa: '8404110001',
  tenjinkawa: '8707020001',
  tenpakugawa_1: '2300520001',
  tenryuugawa: '8505050001',
  teshiogawa: '8101010001',
  tokachigawa: '8101080001',
  tokorogawa: '8101110001',
  tonegawa: '8303030001',
  toyokawa: '8505060001',
  tsurumigawa: '8303060001',
  tsutsumikawa_1: '0200360001',
  utagawa: '0700060001',
  yabegawa_1: '8909070001',
  yahagigawa: '8505070001',
  yakkangawa: '4400080001',
  yamagunigawa: '8909200001',
  yamatogawa: '8606030001',
  yodogawa: '8606040001',
  yoneshirogawa: '8202080001',
  yoshiigawa: '8707130001',
  yoshinogawa: '8808070001',
  yuragawa_1: '8606090001',
  yuragawa_3: '3100270001',
  yuubetsugawa: '8101120001'
}
